export default __webpack_public_path__ + "static/media/ventrilla-res3.0e85f708.jpg";